import { createStyles, IconButton, makeStyles, Tooltip } from "@material-ui/core";
import React, { createRef, useEffect, useState } from "react";
import { blueGrey, cyan, indigo, lightBlue } from '@material-ui/core/colors';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import NotListedLocationIcon from '@material-ui/icons/NotListedLocation';
//import TocIcon from '@material-ui/icons/Toc';
import MapIcon from '@material-ui/icons/Map';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import * as mapsUtil from '../../../mapsutil/MapsUtil';
import { useDispatch } from "react-redux";

import {  IOcorrencia } from "../../../store/Models";
import { fetchListaOcorrencias, IQueryParams } from "./effects";
import 'leaflet.markercluster/dist/leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.heat/dist/leaflet-heat';
import { createLayerOcorrencias } from "./businessLogic";
import { PanelToolBarFull, PanelToolBarFullSeparator } from "../../base-panels/PanelToolbarFull";
import { PanelLayers } from "../../base-panels/PanelLayers";
import { FormOcorrencias } from "./FormOcorrencias";
//import { Tabelas } from "./Tabelas";
import { Graficos } from "./Graficos";
import { doLeEstadosAction } from "../../../actions/EstadosAction";
import { getLegendLeaflet } from "./LegendLeaflet";
import { Camadas } from "./Camadas";
import { ILegendData, legenda_algodao, legenda_arroz, legenda_cana, legenda_milho, legenda_padrao, legenda_soja, legenda_trigo } from "./localData";

delete (L.Icon.Default as any).prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});


const styleMap = {
    height: 'calc(100vh - 48px)',
    width: '100%',
    marginTop: '0px',
    zIndex: 0
}

// especificações para os paineis

const _TOOLTIP_CONSULTA = "Consultar Ocorrências no Mapa";
const _TOOLTIP_GRAFICOS = "Apresenta o resultado da consulta em formato de gráficos";
//const _TOOLTIP_TABELAS = "Apresenta o resultado da consulta em formato de dados tabulares";
const _TOOLTIP_CAMADAS = "Acrescenta camadas ao mapa";

const _COLOR_BAR_CONSULTA = cyan[100];
const _COLOR_BAR_GRAFICOS = indigo[100];
const _COLOR_BAR_TABELAS = blueGrey[100];
const _COLOR_BAR_CAMADAS = lightBlue[100];

const useStylesMapPanels = makeStyles(() =>
    createStyles({
        selectedButtonConsulta: {
            backgroundColor: _COLOR_BAR_CONSULTA
        },
        selectedButtonGraficos: {
            backgroundColor: _COLOR_BAR_GRAFICOS
        },
        selectedButtonTabelas: {
            backgroundColor: _COLOR_BAR_TABELAS
        },
        selectedButtonCamadas: {
            backgroundColor: _COLOR_BAR_CAMADAS
        },
        normalButton: {
            backgroundColor: 'none'
        }
    }),
);

// interface para o contexto da App
export interface IMapaOcorrenciasContext {
    filterOcorrencias: Array<IOcorrencia>,
    setFilterOcorrencias(ocorrencias: Array<IOcorrencia>): any,
    map: L.Map | undefined,
    changeLayer (tipoMapa: string): any
}

// contexto da aplicação
export const MapOcorrenciasContext = React.createContext({} as IMapaOcorrenciasContext);


export const MapaOcorrencias: React.FC = () => {

    const stylesMapPanels = useStylesMapPanels();
    const mapRef = createRef<HTMLDivElement>();
    const dispatch = useDispatch();

    const [map, setMap] = useState<L.Map>();

    //const [ocorrencias, setOcorrencias] = useState<Array<IOcorrencia>>([]);
    const [filterOcorrencias, setFilterOcorrencias] = useState<Array<IOcorrencia>>([]);

    // states para os paineis
    const [showPanelConsulta, setShowPanelConsulta] = useState(true);
    const [showPanelGraficos, setShowPanelGraficos] = useState(false);
    //const [showPanelTabelas, setShowPanelTabelas] = useState(false);
    const [showPanelCamadas, setShowPanelCamadas] = useState(false);
    const [layerAtual, setLayerAtual] = useState<L.Layer>();
    const [legendaAtual, setLegendaAtual] = useState<L.Control>();


    const changeLayer = async (tipoMapa: string) => {
        if (map) {
            layerAtual && map.removeLayer(layerAtual);
            legendaAtual && map.removeControl(legendaAtual);
            if (tipoMapa !== 'nenhuma'){
                const layer =  getLayer(tipoMapa);
                setLayerAtual(layer);
                let legendaData: ILegendData = getLegendData(tipoMapa);
                let legenda_cultura: L.Control = getLegendLeaflet('topleft',legendaData.title,legendaData.labels,legendaData.colors);
                map.addControl(legenda_cultura);
                setLegendaAtual(legenda_cultura);
                map.addLayer(layer);
            } 
            await createLayers(map);
        }
    }

    const getLayer = (tipoMapa: string): L.Layer => {
            return mapsUtil.createLayer('http://mapas.cnpm.embrapa.br/geoserver_apps/wms', `bayer:${tipoMapa}_2019`);
    }

    const getLegendData= (tipoMapa: string): ILegendData =>{
        let legenda: ILegendData = legenda_trigo;
        switch (tipoMapa){
            case 'algodao': legenda = legenda_algodao;
            break;
            case 'arroz': legenda = legenda_arroz;
            break;
            case 'cana': legenda = legenda_cana;
            break;
            case 'milho': legenda = legenda_milho;
            break;
            case 'soja': legenda = legenda_soja;
            break;
            case 'trigo': legenda = legenda_trigo;
            break;
        }
        return legenda;
    }
        
    const createLayers = async (map: L.Map) => {
        // remove as marcas antigas
        map && map.eachLayer(l => {
            // @ts-ignore
            l.layer_type_group && map.removeLayer(l);
            return l;
        });
        
        let groupLayers = L.layerGroup();
      
        // @ts-ignore
        groupLayers['layer_type_group'] = true;
        map.addLayer(groupLayers);
    }


    useEffect(() => {

        const exec = async () => {

            let mapa = L.map('map', {
                center: [-14, -40],
                zoom: 5,
                minZoom: 5
            });

            // layer OSM
            mapa.addLayer(mapsUtil.createMapOSM('http://{s}.tile.osm.org/{z}/{x}/{y}.png'));
           
            // carga dos dados
            dispatch(doLeEstadosAction());

            // carga das ocorrencias - exibe TODAS resistentes
            const parametros: IQueryParams = {
                weedResponse: 'Resistant'
            };
            const ocorrs: Array<IOcorrencia> = await fetchListaOcorrencias(parametros);

            if(!ocorrs) return;

            createLayerOcorrencias(mapa, ocorrs);
            mapa.addControl(getLegendLeaflet('bottomleft',legenda_padrao.title,legenda_padrao.labels,legenda_padrao.colors));
            
            var logo = new L.Control({ position: 'topleft' });
            logo.onAdd = function(map){
                var div = L.DomUtil.create('div', 'myclass');
                div.innerHTML= "<img src='/assets/images/embrapa_colorido.png'/>";
                return div;
            }
            logo.addTo(mapa);
            
            setMap(mapa);
            
            setFilterOcorrencias([...ocorrs]);

        };

        exec();

    }, [dispatch]);

    const ButtonConsultaOcorrencias: React.FC = () => {
        return (

            <Tooltip title={_TOOLTIP_CONSULTA}>
                <IconButton className={showPanelConsulta ? stylesMapPanels.selectedButtonConsulta : stylesMapPanels.normalButton}
                    onClick={() => {
                        setShowPanelConsulta(!showPanelConsulta);
                    }}
                    color="inherit"
                >
                    <NotListedLocationIcon />
                </IconButton>
            </Tooltip>

        )
    }

    // Botao que apresenta os gráficos da ocorrência
    const ButtonGraficosOcorrencias: React.FC = () => {
        return (
            <Tooltip title={_TOOLTIP_GRAFICOS}>
                <IconButton className={showPanelGraficos ? stylesMapPanels.selectedButtonGraficos : stylesMapPanels.normalButton}
                    onClick={() => {
                        setShowPanelGraficos(!showPanelGraficos);
                    }}
                    color="inherit"
                >
                    <EqualizerIcon />
                </IconButton>
            </Tooltip>
        )
    }
/*
    // Botao que apresenta os gráficos da ocorrência
    const ButtonTabelasOcorrencias: React.FC = () => {
        return (
            <Tooltip title={_TOOLTIP_TABELAS}>
                <IconButton className={showPanelTabelas ? stylesMapPanels.selectedButtonTabelas : stylesMapPanels.normalButton}
                    onClick={() => {
                        setShowPanelTabelas(!showPanelTabelas);
                    }}
                    color="inherit"
                >
                    <TocIcon />
                </IconButton>
            </Tooltip>
        )
    }
*/
    const ButtonCamadas: React.FC = () => {
        return (
            <Tooltip title={_TOOLTIP_CAMADAS}>
                <IconButton className={showPanelCamadas ? stylesMapPanels.selectedButtonTabelas : stylesMapPanels.normalButton}
                    onClick={() => {
                        setShowPanelCamadas(!showPanelCamadas);
                    }}
                    color="inherit"
                >
                    <MapIcon />
                </IconButton>
            </Tooltip>
        )
    }


    return (

        <div>
            <MapOcorrenciasContext.Provider value={{
               
                filterOcorrencias: filterOcorrencias,
                setFilterOcorrencias: setFilterOcorrencias,
                map: map,
                changeLayer: changeLayer
            }}>

                <div id='map' style={styleMap} ref={mapRef}>
                </div >

                <PanelLayers
                    title={'Consulta de Ocorrências'}
                    colorTitle='#4d4b4b'
                    colorBar={_COLOR_BAR_CONSULTA}
                    width={'500px'}
                    positionAlign='right'
                    zIndex={10}
                    showPanel={showPanelConsulta}
                    iconBar={<NotListedLocationIcon />}
                    onButtonCloseClicked={(value) => setShowPanelConsulta(value)}
                >
                    <FormOcorrencias />
                </PanelLayers>
                {/*
                <PanelLayers
                    title={'Ocorrências da Consulta'}
                    colorTitle='#4d4b4b'
                    colorBar={_COLOR_BAR_TABELAS}
                    width={'900px'}
                    positionAlign='left'
                    zIndex={0}
                    showPanel={showPanelTabelas}
                    iconBar={<NotListedLocationIcon />}
                    onButtonCloseClicked={(value) => setShowPanelTabelas(value)}
                >
                    <Tabelas />
                </PanelLayers>
                */}
                <PanelLayers
                    title={'Gráficos das Ocorrências'}
                    colorTitle='#4d4b4b'
                    colorBar={_COLOR_BAR_GRAFICOS}
                    width={'900px'}
                    positionAlign='left'
                    zIndex={0}
                    showPanel={showPanelGraficos}
                    iconBar={<NotListedLocationIcon />}
                    onButtonCloseClicked={(value) => setShowPanelGraficos(value)}
                >
                    <Graficos/>
                </PanelLayers>

                <PanelLayers
                    title={'Camadas do Mapa'}
                    colorTitle='#4d4b4b'
                    colorBar={_COLOR_BAR_CAMADAS}
                    width={'500px'}
                    positionAlign='right'
                    zIndex={10}
                    showPanel={showPanelCamadas}
                    iconBar={<NotListedLocationIcon />}
                    onButtonCloseClicked={(value) => setShowPanelCamadas(value)}
                >
                    <Camadas />
                </PanelLayers>

                <PanelToolBarFull startOpened={true}>
                    <ButtonConsultaOcorrencias />
                    <PanelToolBarFullSeparator />
                    <ButtonGraficosOcorrencias />
                    <PanelToolBarFullSeparator />
                    {/*<ButtonTabelasOcorrencias />
                    <PanelToolBarFullSeparator />
                    */}
                    <ButtonCamadas />
                </PanelToolBarFull>

            </MapOcorrenciasContext.Provider>

        </div>

    );
}